module.exports = __webpack_public_path__ + "img/G-store-logo2.e5710e5a.png";